import Vue from 'vue';
import Router from 'vue-router';
import axios from 'axios';
import Consumption from '@/views/Consumption.vue';
import Permissions from '@/views/Permissions.vue';
import Maps from '@/views/Maps.vue';
import ConfChoice from '@/views/ConfChoice.vue';
import MapsList from '@/views/MapsList.vue';
import MapsEdit from '@/views/MapsEdit.vue';
import App from '@/App.vue';
import store from './store/index';

Vue.use(Router);

const router = new Router({
  routes: [
    {
      path: '/',
      redirect: '/maps',
    },
    {
      path: '/maps',
      component: Maps,
      children: [
        {
          path: '',
          name: 'maps_list',
          component: MapsList,
        },
        {
          path: ':id(\\d+)',
          name: 'map_edit',
          component: MapsEdit,
          meta: { title: 'Détails' },
        },
      ],
      meta: { title: 'Mes cartes' },
    },
    {
      path: '/consumption',
      name: 'consumption',
      component: Consumption,
      meta: { title: 'Consommation' },
    },
    {
      path: '/choice',
      name: 'choice',
      component: ConfChoice,
    },
    {
      path: '/noRole',
      name: 'noRole',
      component: App,
      meta: { isPublic: true },
    },
    {
      path: '/permissions',
      name: 'permissions',
      component: Permissions,
      meta: { title: 'Diffusion' },
    },
    {
      path: '/login',
      name: 'login',
      beforeEnter() {
        if (window.location.host === 'account.touristicmaps.com') {
          window.location = 'https://connect.studio.raccourci.fr/oauth/v2/auth?client_id=3_582geteg4eckcwcscwo4kwwgcowk8cgo00cccksc0w040s8s4c&response_type=code&redirect_uri=https%3A%2F%2Faccount.touristicmaps.com%2Fapi%2Fv2%2Ftmaps%2Fcallback&state=cb3565edc82597263424562dc55d1d0445943f1f&application=touristicmaps';
        } else if (window.location.host === 'account.touristicmaps.rc-preprod.com') {
          window.location = 'https://connect.studio.raccourci.fr/oauth/v2/auth?client_id=3_582geteg4eckcwcscwo4kwwgcowk8cgo00cccksc0w040s8s4c&response_type=code&redirect_uri=https%3A%2F%2Faccount.touristicmaps.rc-preprod.com%2Fapi%2Fv2%2Ftmaps%2Fcallback&state=cb3565edc82597263424562dc55d1d0445943f1f&application=touristicmaps';
        } else {
          window.location = 'https://connect.studio.raccourci.fr/oauth/v2/auth?client_id=3_582geteg4eckcwcscwo4kwwgcowk8cgo00cccksc0w040s8s4c&response_type=code&redirect_uri=http%3A%2F%2Flocalhost:3000%2Fapi%2Fv2%2Ftmaps%2Fcallback&state=cb3565edc82597263424562dc55d1d0445943f1f&application=touristicmaps';
        }
      },
      meta: { isPublic: true },
    },
  ],
});


function getRouteOptions(to) {
  const meta = typeof to.meta === 'undefined' ? { isPublic: false } : to.meta;
  return meta;
}

function IHaveRole(requiredRole) {
  const { roles } = store.state.user.logged;
  return roles.filter(role => role === requiredRole).length > 0;
}

async function handlePrivateRoute(to, next, routeOptions) {
  let redirectRoute;
  if (!store.state.user.logged.login) {
    redirectRoute = {
      name: 'login',
    };
  } else if (!routeOptions.isPublic && !IHaveRole('touristic_maps_admin')) {
    redirectRoute = {
      name: 'noRole',
    };
  }

  if (store.state.user.logged.raccourci) {
    const doc = document.createElement('script');
    doc.setAttribute('src', 'https://connect.studio.raccourci.fr/oauth/v2/logout');
    document.body.append(doc);
  }

  next(redirectRoute);
}


router.beforeEach(async (to, from, next) => {
  const routeOptions = getRouteOptions(to);
  if (!store.state.user.login && to.query.token) {
    try {
      await axios.get(`/api/v2/tmaps/validate_token?token=${to.query.token}`);
    } catch (error) {
      window.parent.postMessage('token_validate_error', '*');
    }
  }
  if (to.name !== 'login') {
    if (!store.state.user.login) {
      store
        .dispatch('user/getCurrent')
        .finally(() => handlePrivateRoute(to, next, routeOptions));
    } else {
      handlePrivateRoute(to, next, routeOptions);
    }
  } else {
    next();
  }
});

export default router;
